import { render, staticRenderFns } from "./AuditoriaGestoesDeAulas.vue?vue&type=template&id=33f94ccc"
import script from "./AuditoriaGestoesDeAulas.vue?vue&type=script&lang=js"
export * from "./AuditoriaGestoesDeAulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports